import { FILTER_EQUIPMENTS } from './filterequipments.type';

export const setEquipmentsFilter = (setFilter) => {
  return {
    type: FILTER_EQUIPMENTS,
    payload: setFilter
  };
};
